module.exports = __webpack_public_path__ + "static/media/ebooks.5001e31c.png";